import React from "react";
import styled, { keyframes } from "styled-components";

/**
 * SurveyLoader
 * - Full-width/contained loader that matches your palette/typography
 * - Subtle progress shimmer + three-dot pulse
 */
const SurveyLoader = ({ title = "Loading survey", subtitle = "Retrieving data…" }) => {
  return (
    <Wrap role="status" aria-live="polite">
      <Heading>{title}</Heading>
      <Subtext>{subtitle}</Subtext>

      <Bar aria-hidden="true">
        <Fill />
      </Bar>

      <Dots aria-hidden="true">
        <Dot />
        <Dot />
        <Dot />
      </Dots>
    </Wrap>
  );
};

export default SurveyLoader;

/* ===== styles ===== */

const Wrap = styled.div`
  width: 100%;
  max-width: 620px;
  min-height: 240px;

  display: grid;
  grid-template-rows: auto auto auto auto auto;
  align-content: center;
  justify-items: start;
  gap: 14px;

  padding: 28px 24px;
  border: 1px solid #e6edf9;
  border-radius: 16px;
  background: #ffffff;
  box-shadow: 0 6px 24px rgba(31, 60, 114, 0.06);
  font-family: "Raleway", sans-serif;
`;

const Heading = styled.h2`
  margin: 2px 0 0 0;
  color: #2a3039;
  font-size: 20px;
  font-weight: 600;
`;

const Subtext = styled.div`
  color: #666d79;
  font-size: 14px;
`;

const shimmer = keyframes`
  0% { transform: translateX(-100%); }
  100% { transform: translateX(100%); }
`;

const Bar = styled.div`
  position: relative;
  width: 100%;
  height: 8px;
  background: #d5e2f9;
  border-radius: 10px;
  overflow: hidden;
  margin-top: 6px;
`;

const Fill = styled.div`
  position: absolute;
  inset: 0;
  transform: translateX(-100%);
  background: linear-gradient(
    90deg,
    rgba(45, 112, 226, 0) 0%,
    rgba(45, 112, 226, 0.15) 40%,
    rgba(45, 112, 226, 0.3) 60%,
    rgba(45, 112, 226, 0) 100%
  );
  animation: ${shimmer} 1.3s infinite;
`;

const pulse = keyframes`
  0%, 80%, 100% { opacity: .2; transform: scale(.9) }
  40% { opacity: 1; transform: scale(1) }
`;

const Dots = styled.div`
  display: inline-flex;
  gap: 6px;
  margin-top: 2px;
`;

const Dot = styled.span`
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #2d70e2;
  animation: ${pulse} 1.4s infinite ease-in-out both;

  &:nth-child(1) { animation-delay: 0s; }
  &:nth-child(2) { animation-delay: .2s; }
  &:nth-child(3) { animation-delay: .4s; }
`;
